<template>
  <!--
    Bloque de consentimiento compartido (SMS + Email).
    Markup HTML plano con el look del SignUpWizard. Los ValidationProvider
    se mantienen para los formularios que todavía usan vee-validate
    (agent / employee / vendor signups, envueltos en un ValidationObserver):
    en esos casos `errors` se renderiza debajo del checkbox. El SignUpWizard
    y el formulario de referral lo usan fuera de un observer y compuertan el
    submit directamente con `smsConsent && emailConsent`, así que los
    providers quedan como no-ops inofensivos ahí.
  -->
  <div class="consent-container">
    <ValidationProvider rules="required-check" v-slot="{ errors }">
      <div class="consent-row">
        <input
          id="consent-sms"
          v-model="localSmsConsent"
          type="checkbox"
          class="consent-checkbox"
        />
        <label for="consent-sms" class="consent-text">
          I consent to receive SMS notifications from Kiey (admin.kiey.com) regarding account activity, alerts, and messages. Msg frequency varies. Msg &amp; data rates may apply. Text STOP to cancel, HELP for help. <a href="https://kiey.com/privacy-policy.html" target="_blank" rel="noopener" class="consent-link" @click.stop>Privacy Policy</a> | <a href="https://kiey.com/terms.html" target="_blank" rel="noopener" class="consent-link" @click.stop>Terms of Service</a>
        </label>
      </div>
      <span v-if="errors && errors.length" class="consent-error">{{ errors[0] }}</span>
    </ValidationProvider>

    <ValidationProvider rules="required-check" v-slot="{ errors }">
      <div class="consent-row">
        <input
          id="consent-email"
          v-model="localEmailConsent"
          type="checkbox"
          class="consent-checkbox"
        />
        <label for="consent-email" class="consent-text">
          I consent to receive email notifications from Kiey regarding account activity, alerts, and messages. You may unsubscribe at any time. <a href="https://kiey.com/privacy-policy.html" target="_blank" rel="noopener" class="consent-link" @click.stop>Privacy Policy</a>
        </label>
      </div>
      <span v-if="errors && errors.length" class="consent-error">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "ConsentCheckboxes",
  components: { ValidationProvider },
  props: {
    smsConsent: { type: Boolean, default: false },
    emailConsent: { type: Boolean, default: false },
  },
  computed: {
    localSmsConsent: {
      get() { return this.smsConsent; },
      set(val) { this.$emit('update:smsConsent', val); }
    },
    localEmailConsent: {
      get() { return this.emailConsent; },
      set(val) { this.$emit('update:emailConsent', val); }
    }
  }
};
</script>

<style scoped>
/* Look del SignUpWizard — checkbox HTML plano, no Vuetify. Se usan
   literales en lugar de tokens --kiey-* porque este componente también
   vive en signups (agent/employee/vendor) que no exponen esos tokens. */
.consent-container {
  margin-top: 4px;
  padding: 16px;
  border-radius: 12px;
  background: #F8FAFC;
  border: 1px solid #E6ECF5;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.consent-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.consent-checkbox {
  width: 18px;
  height: 18px;
  min-width: 18px;
  border-radius: 4px;
  border: 1px solid #C7D2E0;
  margin-top: 2px;
  cursor: pointer;
  accent-color: #2F6FED;
  box-shadow: none;
}

.consent-text {
  font-size: 12px !important;
  line-height: 1.4 !important;
  color: #475467 !important;
  cursor: pointer;
  font-weight: 400 !important;
  letter-spacing: 0 !important;
  font-family: inherit !important;
  text-transform: none !important;
  transform: none !important;
  max-width: 100% !important;
  flex: 1 1 auto;
}

.consent-link {
  color: #2F6FED;
  font-weight: 600;
  text-decoration: none;
}

.consent-link:hover {
  text-decoration: underline;
}

.consent-error {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #DC3545;
}

@media (max-width: 600px) {
  .consent-container {
    padding: 12px;
  }

  .consent-checkbox {
    width: 20px;
    height: 20px;
    min-width: 20px;
  }
}

@media (max-width: 380px) {
  .consent-text {
    font-size: 11.5px !important;
    line-height: 1.4 !important;
  }
}

@media (max-height: 720px) {
  .consent-container {
    padding: 10px;
    gap: 8px;
  }

  .consent-text {
    font-size: 11px;
    line-height: 15px;
  }
}
</style>
